export default __webpack_public_path__ + "static/media/menu_vendor.85bc1939.png";